/** Local runtime identity; never derive this from a reusable port slot. */
export function environmentSessionName(name: string, environmentId?: string): string {
  if (!environmentId) return name;
  if (!/^[a-f0-9]{32}$/.test(environmentId)) {
    throw new Error("Invalid local runtime session identity");
  }
  return `${name}_${environmentId}`;
}

/** Remove only our authentication state when a loopback slot changes owner. */
export function initializeEnvironmentSession(
  environmentId: string | undefined,
  local: Storage,
  session: Storage,
): void {
  if (!environmentId) return;
  environmentSessionName("session", environmentId);
  const marker = "dronejob:runtimeIdentity";
  if (local.getItem(marker) === environmentId) return;
  for (const storage of [local, session]) {
    const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i));
    for (const key of keys) {
      if (key && (key.startsWith("@@auth0spajs@@") || key.startsWith("a0.spajs.txs.") || ["dronejob:requestLogout", "dronejob:externalAuthReturnTo", "dronejob:postLogoutRoute"].includes(key))) {
        storage.removeItem(key);
      }
    }
  }
  local.setItem(marker, environmentId);
}
